<div class="lab-details-container">
  @if (dataSource) {
    <div class="labDetailsData-details-table">
      <div class="row mb-4">
        <div class="col-md-4">
          <label class="filter-label">Filter By</label>
          <input class="form-control searchInput" matInput placeholder="Search Records" (keyup)="applyFilter($event)" #input>
        </div>
      </div>
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        <ng-container matColumnDef="observationDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Observation</th>
          <td mat-cell *matCellDef="let row">{{ row.observationDate |  date:'MM/dd/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="orderingProviderId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Ordering Provider ID</th>
          <td mat-cell *matCellDef="let row">{{ row.orderingProviderId }}</td>
        </ng-container>
        <ng-container matColumnDef="orderingProvider">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Ordering Provider</th>
          <td mat-cell *matCellDef="let row">{{ row.orderingProviderFirstName }}, {{ row.orderingProviderLastName }}</td>
        </ng-container>
        <ng-container matColumnDef="valueType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Value Type</th>
          <td mat-cell *matCellDef="let row">{{ row.valueType }}</td>
        </ng-container>
        <ng-container matColumnDef="loinc">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>LOINC</th>
          <td mat-cell *matCellDef="let row">{{ row.loinc }}</td>
        </ng-container>
        <ng-container matColumnDef="loincDescription">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>LOINC Description</th>
          <td mat-cell *matCellDef="let row">{{ row.loincDescription }}</td>
        </ng-container>
        <ng-container matColumnDef="observationValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Observation Value</th>
          <td mat-cell *matCellDef="let row">{{ row.observationValue }}</td>
        </ng-container>
        <ng-container matColumnDef="units">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Units</th>
          <td mat-cell *matCellDef="let row">{{ row.units }}</td>
        </ng-container>
        <ng-container matColumnDef="referencesRange">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Reference Range</th>
          <td mat-cell *matCellDef="let row">{{ row.referencesRange }}</td>
        </ng-container>
        <ng-container matColumnDef="abnormalFlags">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Abnormal Flag</th>
          <td mat-cell *matCellDef="let row">{{ row.abnormalFlags }}</td>
        </ng-container>
        <ng-container matColumnDef="observationComment">
          <th mat-header-cell *matHeaderCellDef>Observation Comment</th>
          <td mat-cell *matCellDef="let row;let i = index">
            {{isExpanded(row)?row.observationComment:(row.observationComment | slice:0:40)}}
            @if (row.observationComment?.length > 40) {
              <span>
                <span>
                  <a class="toggleShowLink" (click)="toggle(row)">
                    {{isExpanded(row)?'less' : 'More'}}
                  </a>
                </span>
              </span>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
      </mat-paginator>
    </div>
  }
</div>

<!-- Dialog box -->
<div class="modal commentViewModalPopup" id="commentViewModal" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Comment</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <p>{{currentComment}}</p>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <div>
          <button type="button" class="btn carelon-btn buttonInfo" data-bs-dismiss="modal">CLOSE</button>
        </div>
      </div>
    </div>
  </div>
</div>